// src/realtime/sse-parser.ts
import type { Frame } from "./types";

/** يحوّل كتلة SSE واحدة (سطور id/event/data) إلى إطار؛ التعليقات (: ping) تصير إطار ping. */
export function parseBlock(block: string): Frame | null {
  let event = "message";
  let id: string | undefined;
  const data: string[] = [];
  let comment = false;
  for (const line of block.split("\n")) {
    if (line.startsWith(":")) comment = true;
    else if (line.startsWith("event:")) event = line.slice(6).trim();
    else if (line.startsWith("id:")) id = line.slice(3).trim();
    else if (line.startsWith("data:")) data.push(line.slice(5).replace(/^ /, ""));
  }
  if (!data.length) return comment ? { kind: "ping", data: {} as Record<string, never> } : null;
  try {
    return { kind: event, data: JSON.parse(data.join("\n")), id } as Frame;
  } catch {
    return null;
  }
}

/** مُجزّئ متدفق: يستقبل قطعاً نصية ويُخرج الإطارات الكاملة فقط. */
export function createSseParser(onFrame: (f: Frame) => void) {
  let buffer = "";
  return (chunk: string) => {
    buffer += chunk.replace(/\r\n/g, "\n");
    let i: number;
    while ((i = buffer.indexOf("\n\n")) >= 0) {
      const block = buffer.slice(0, i);
      buffer = buffer.slice(i + 2);
      const frame = block.trim() ? parseBlock(block) : null;
      if (frame) onFrame(frame);
    }
  };
}
